module.exports = __webpack_public_path__ + "img/img_product_05@2x.f4dc8b0e.png";